/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { Collapse } from "antd";
import { collapsableItemStyle } from "./styles";
import { ICollapsableItemProps } from "./interfaces";
import { GA_Event } from "../../utils/reactGA";
import { GAEvents } from "../../constants/commons";

const { Panel } = Collapse;

export const CollapsableItem: React.FC<ICollapsableItemProps> = (
  props: ICollapsableItemProps
) => {
  const { heading, description, data } = props;

  const panelElement =
    data &&
    data.map((paneldata, key) => {
      return (
        <Panel header={paneldata.headerText} key={key.toString()}>
          {paneldata.itemBody}
        </Panel>
      );
    });
  return (
    <span css={collapsableItemStyle}>
      <div className="collapsable-card-container">
        <h5 className="header-style">{heading}</h5>
        <p className="decsription-style">{description}</p>
        <div className="scrollable-container">
          <Collapse
            accordion={true}
            onChange={() => {
              GA_Event(GAEvents.FAQ, "clicked");
            }}
          >
            {panelElement}
          </Collapse>
        </div>
      </div>
    </span>
  );
};
